import type { MemberOrdersResponse } from './myOrdersLogic'

type Profile = NonNullable<MemberOrdersResponse['memberProfile']>

/** ข้อมูลนำเข้าจากออร์เดอร์เป็นเพียงค่าเริ่มต้น ลูกค้าต้องยืนยันเองก่อนรับสิทธิ์ */
export function isMemberProfileReady(profile?: Profile): boolean {
  return !!profile && !profile.needsSetup && (profile.source === 'member' || profile.source === 'admin')
}

/** ชื่อ เบอร์ ที่อยู่ ครบแล้ว เหลือแค่วันเกิด (ไม่มี/ไม่ทราบ) — ข้อความ "เหลืออีกขั้นเดียว" */
export function isOnlyBirthdayMissing(profile?: Pick<Profile, 'recipientName' | 'phone' | 'address' | 'birthday'>): boolean {
  if (!profile) return false
  const basics = !!String(profile.recipientName || '').trim() && /^0\d{8,9}$/.test(String(profile.phone || '').replace(/[^\d]/g, '')) && !!String(profile.address || '').trim()
  const parts = String(profile.birthday || '').split('/').map((p) => p.trim())
  const birthdayOk = parts.length === 3 && parts.every((p) => p && p !== 'ไม่ทราบ')
  return basics && !birthdayOk
}

export function canUseMemberBenefits(data: MemberOrdersResponse): boolean {
  return data.benefitsEligible ?? isMemberProfileReady(data.memberProfile)
}
